import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence, useScroll, useTransform } from "framer-motion";

  // --- INLINED ICONS (ZERO DEPENDENCY) ---
  // We explicitly define SVG paths to avoid any CDN blocks.
  const ICON_PATHS = {
    Menu: <path d="M4 12h16M4 6h16M4 18h16"/>,
    X: <path d="M18 6 6 18M6 6l12 12"/>,
    Clock: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    FileWarning: <><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><path d="M12 9v4"/><path d="M12 17h.01"/></>,
    PenTool: <><path d="m12 19 7-7 3 3-7 7-3-3z"/><path d="m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/><path d="m2 2 7.586 7.586"/><circle cx="11" cy="11" r="2"/></>,
    Layers: <><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/></>,
    ChevronLeft: <path d="m15 18-6-6 6-6"/>,
    ChevronRight: <path d="m9 18 6-6-6-6"/>,
    Network: <><rect x="16" y="16" width="6" height="6" rx="1"/><rect x="2" y="16" width="6" height="6" rx="1"/><rect x="9" y="2" width="6" height="6" rx="1"/><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"/><path d="M12 12V8"/></>,
    Cpu: <><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><path d="M15 2v2"/><path d="M15 20v2"/><path d="M2 15h2"/><path d="M2 9h2"/><path d="M20 15h2"/><path d="M20 9h2"/><path d="M9 2v2"/><path d="M9 20v2"/></>,
    Database: <><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></>,
    History: <><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 12"/><path d="M3 3v9h9"/><path d="M12 7v5l4 2"/></>,
    ShieldCheck: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></>,
    Smartphone: <><rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/></>,
    Check: <path d="M20 6 9 17l-5-5"/>,
    HardHat: <><path d="M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z"/><path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"/></>,
    Zap: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>,
    Lightbulb: <><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-1 1.5-2 1.5-3.5 0-3.33-2.67-6-6-6s-6 2.67-6 6c0 1.5.5 2.5 1.5 3.5.8.8 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></>,
    Calculator: <><rect width="16" height="20" x="4" y="2" rx="2"/><line x1="8" x2="16" y1="6" y2="6"/><line x1="16" x2="16" y1="14" y2="18"/><path d="M16 10h.01"/><path d="M12 10h.01"/><path d="M8 10h.01"/><path d="M12 14h.01"/><path d="M8 14h.01"/><path d="M12 18h.01"/><path d="M8 18h.01"/></>,
    Users: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    FileText: <><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" x2="8" y1="13" y2="13"/><line x1="16" x2="8" y1="17" y2="17"/><line x1="10" x2="8" y1="9" y2="9"/></>,
    DollarSign: <><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></>,
    Hammer: <><path d="m15 12-8.5 8.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L12 9"/><path d="M17.64 15 22 10.64"/><path d="m20.91 11.7-1.25-1.25c-.6-.6-.93-1.4-.93-2.25V7.86c0-.55-.45-1-1-1H14.5c-.85 0-1.65-.33-2.25-.93L11 4.64"/><path d="M17.64 15c.6.6 1.4.93 2.25.93H21c.55 0 1-.45 1-1v-3.26c0-.85-.33-1.65-.93-2.25L17.64 15z"/></>,
    Send: <><line x1="22" x2="11" y1="2" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>,
    CheckCircle: <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>
  };

  // Generic Icon Component
  const Icon = ({ name, size = 24, className = "" }) => {
    const content = ICON_PATHS[name];
    if (!content) return null;
    return (
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        className={className}
      >
        {content}
      </svg>
    );
  };

  // Icon Registry
  const Icons = {
    Menu: (p) => <Icon name="Menu" {...p} />,
    X: (p) => <Icon name="X" {...p} />,
    Clock: (p) => <Icon name="Clock" {...p} />,
    FileWarning: (p) => <Icon name="FileWarning" {...p} />,
    PenTool: (p) => <Icon name="PenTool" {...p} />,
    Layers: (p) => <Icon name="Layers" {...p} />,
    ChevronLeft: (p) => <Icon name="ChevronLeft" {...p} />,
    ChevronRight: (p) => <Icon name="ChevronRight" {...p} />,
    Network: (p) => <Icon name="Network" {...p} />,
    Cpu: (p) => <Icon name="Cpu" {...p} />,
    Database: (p) => <Icon name="Database" {...p} />,
    History: (p) => <Icon name="History" {...p} />,
    ShieldCheck: (p) => <Icon name="ShieldCheck" {...p} />,
    Smartphone: (p) => <Icon name="Smartphone" {...p} />,
    Check: (p) => <Icon name="Check" {...p} />,
    HardHat: (p) => <Icon name="HardHat" {...p} />,
    Zap: (p) => <Icon name="Zap" {...p} />,
    Lightbulb: (p) => <Icon name="Lightbulb" {...p} />,
    Calculator: (p) => <Icon name="Calculator" {...p} />,
    Users: (p) => <Icon name="Users" {...p} />,
    FileText: (p) => <Icon name="FileText" {...p} />,
    DollarSign: (p) => <Icon name="DollarSign" {...p} />,
    Hammer: (p) => <Icon name="Hammer" {...p} />,
    Send: (p) => <Icon name="Send" {...p} />,
    CheckCircle: (p) => <Icon name="CheckCircle" {...p} />
  };

      // --- CONFIGURATION ---
  // All assets are served locally from /assets (see public/assets). These were
  // migrated off the Squarespace CDN so the site has no external Squarespace dependency.
  const LOGO_URL = "/assets/img/logo.webp";
  const HERO_ASSETS = {
    heroImage: "/assets/img/hero.webp"
  };
  const FAN_CARDS_DATA = [
    {
      id: 1,
      title: "1. Electrical Plan",
      description: "Circuit layout and device locations—ready for install.",
      url: "/assets/img/electrical-plan.webp",
      docUrl: "/assets/pdf/electrical-plan.pdf",
      color: "border-brand-500"
    },
    {
      id: 2,
      title: "2. Legend",
      description: "Symbols, notes, and conventions used across the plan set.",
      url: "/assets/img/legend.webp",
      docUrl: "/assets/pdf/legend.pdf",
      color: "border-brand-400"
    },
    {
      id: 3,
      title: "3. Schematic",
      description: "System-level wiring and topology—how everything connects end-to-end.",
      url: "/assets/img/schematic.webp",
      docUrl: "/assets/pdf/schematic.pdf",
      color: "border-slate-500"
    },
    {
      id: 4,
      title: "4. Quote",
      description: "Itemised scope and pricing aligned to the documentation.",
      url: "/assets/img/quote.webp",
      docUrl: "/assets/pdf/quote.pdf",
      color: "border-indigo-500"
    },
    {
      id: 5,
      title: "5. Order",
      description: "Procurement-ready ordering list to push straight to suppliers.",
      url: "/assets/img/order.webp",
      docUrl: "/assets/pdf/order.pdf",
      color: "border-purple-500"
    }
  ];

  // --- SUB-COMPONENTS ---

  const Logo = ({ className = "h-10" }) => {
    const [err, setErr] = useState(false);
    if (!LOGO_URL || err) {
      return (<span className="text-2xl font-black text-slate-900 tracking-tighter cursor-pointer">MARKAPP<span className="text-brand-600">.</span></span>);
    }
    return <img src={LOGO_URL} alt="MarkApp" className={`w-auto object-contain ${className}`} onError={()=>setErr(true)} />;
  };

  const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navLinks = [
      { label: 'The Problem', href: '#problem' },
      { label: 'Visual Design', href: '#design' },
      { label: 'The Journey', href: '#timeline' },
      { label: 'Job Management', href: '#management' },
      { label: 'Pricing', href: '#pricing' },
    ];
    const scroll = (e, href) => {
      e.preventDefault();
      const el = document.getElementById(href.replace('#',''));
      if(el) {
        setIsMobileMenuOpen(false);
        window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
      }
    };
    return (
      <nav className="fixed top-0 left-0 right-0 z-[9999] bg-slate-200 border-b border-slate-300 shadow-sm h-20 transition-all">
        <div className="max-w-7xl mx-auto px-4 h-full flex items-center justify-between">
          <div onClick={()=>window.scrollTo({top:0,behavior:'smooth'})}><Logo /></div>
          <div className="hidden md:block">
            <div className="flex items-baseline space-x-8">
              {navLinks.map(l => (
                <a key={l.label} href={l.href} onClick={(e)=>scroll(e, l.href)} className="text-slate-700 hover:text-brand-600 px-3 py-2 rounded-md text-sm font-bold cursor-pointer transition-colors">{l.label}</a>
              ))}
              <a href="#waitlist" onClick={(e)=>scroll(e,'#waitlist')} className="bg-brand-600 hover:bg-brand-700 text-white px-5 py-2 rounded-full text-sm font-semibold shadow-md cursor-pointer">Join Waitlist</a>
            </div>
          </div>
          <div className="-mr-2 flex md:hidden">
             <button onClick={()=>setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-slate-700">{isMobileMenuOpen ? <Icons.X /> : <Icons.Menu />}</button>
          </div>
        </div>
        <AnimatePresence>
          {isMobileMenuOpen && (
            <motion.div initial={{opacity:0,height:0}} animate={{opacity:1,height:'auto'}} exit={{opacity:0,height:0}} className="md:hidden bg-slate-200 border-b border-slate-300 px-2 pt-2 pb-3 space-y-1">
               {navLinks.map(l => <a key={l.label} href={l.href} onClick={(e)=>scroll(e,l.href)} className="block px-3 py-2 text-slate-800 font-bold">{l.label}</a>)}
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    );
  };

  const Hero = () => {
    return (
      <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
         <div className="absolute inset-0 bg-slate-950">
            <div className="absolute top-0 -left-4 w-72 h-72 bg-brand-500 rounded-full mix-blend-multiply blur-3xl opacity-20 animate-blob"></div>
            <div className="absolute top-0 -right-4 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
            <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
            <div className="absolute inset-0 markapp-grid-bg"></div>
         </div>
         <div className="relative z-10 max-w-7xl mx-auto px-4 flex flex-col items-center text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700 text-brand-400 text-sm font-medium mt-12 mb-6">
               <span className="w-2 h-2 rounded-full bg-brand-500 animate-pulse"></span> Launching Q1 2026
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">Design, Quote & <br/><span className="text-brand-500">Manage Jobs Smarter</span></h1>
            <p className="max-w-2xl text-xl text-slate-400 mb-10">A cloud-based platform for builders, lighting, electrical, and system integration professionals.</p>

            <motion.div initial={{opacity:0,y:40}} animate={{opacity:1,y:0}} transition={{delay:0.5,duration:0.8}} className="mt-16 w-full max-w-6xl rounded-2xl bg-slate-900 border border-slate-800 shadow-2xl overflow-hidden relative group">
               <img src={HERO_ASSETS.heroImage} className="w-full opacity-90 group-hover:opacity-100 transition-opacity" />
               <div className="absolute inset-0 bg-gradient-to-t from-slate-950 to-transparent"></div>
            </motion.div>
         </div>
      </section>
    );
  };

  const ProblemSection = () => {
    const items = [
      { i: Icons.Clock, t: "Time-Consuming Manual Markup", d: "Manually drawing symbols for power, lighting, data, and automation on generic PDFs is slow and prone to errors. Changes require reworking the entire drawing." },
      { i: Icons.FileWarning, t: "Disconnected Data", d: "Your drawing is just a drawing. It doesn't know that the symbol you just placed is a $200 dimmer switch that needs to be ordered, scheduled, and installed." },
      { i: Icons.PenTool, t: "Reliance on Third Parties", d: "Waiting for project builders' drafters to update plans stalls momentum. Custom homes require agility that traditional CAD workflows can't provide." }
    ];
    return (
      <section id="problem" className="py-24 bg-slate-950">
         <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-white text-center mb-16">The Missing Link in <br/><span className="text-brand-500">Residential Electrical Design</span></h2>
            <div className="grid md:grid-cols-3 gap-8">
               {items.map((item, idx) => (
                 <div key={idx} className="flex flex-col items-start p-6 bg-slate-900 rounded-xl border border-slate-800 hover:border-brand-500/50 transition-colors">
                    <div className="p-3 bg-slate-800 rounded-lg mb-4 text-brand-400"><item.i size={24}/></div>
                    <h3 className="text-lg font-bold text-white mb-2">{item.t}</h3>
                    <p className="text-slate-400 text-sm">{item.d}</p>
                 </div>
               ))}
            </div>
         </div>
      </section>
    );
  };

  const FanOutCards = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const stack = FAN_CARDS_DATA.slice(0, 4);

    useEffect(() => { document.body.style.overflow = isOpen ? 'hidden' : 'unset'; }, [isOpen]);

    return (
      <>
        <div className="relative w-full h-[500px] flex items-center justify-center perspective-1000">
           <motion.div className="relative w-[300px] h-[400px] cursor-pointer group preserve-3d" onClick={()=>{setIsOpen(true);setActiveIndex(0)}} initial="rest" whileHover="hover" animate="rest">
              {[...stack].reverse().map((card, revIndex) => {
                 const index = stack.length - 1 - revIndex; 
                 const isL = card.orientation === 'landscape';
                 let hV = {};
                 if(index===0) hV = { rotate: -10, x: -60, y: 0, scale: 1.05 };
                 else if(index===1) hV = { rotate: -3, x: 40, y: -30 };
                 else if(index===2) hV = { rotate: 5, x: 90, y: -10 };
                 else hV = { rotate: 12, x: 140, y: 20 };
                 return (
                    <motion.div key={card.id} className={`absolute top-1/2 left-1/2 bg-slate-800 rounded-xl border-2 ${card.color} shadow-2xl overflow-hidden origin-center backface-hidden`}
                      style={{ zIndex: stack.length - index, width: isL ? 320 : 240, height: isL ? 200 : 320, marginTop: isL ? -100 : -160, marginLeft: isL ? -160 : -120 }}
                      variants={{ rest: { rotate: (index%2===0?-2:2)*index, x:0, y:0, scale: 1 - (index*0.05) }, hover: { ...hV, scale: 1 } }}
                      transition={{ type: 'spring', stiffness: 120, damping: 20 }}>
                       <img src={card.url} className="w-full h-full object-cover opacity-90"/>
                       <div className="absolute bottom-0 inset-x-0 bg-slate-900/90 p-2 text-center text-xs font-bold text-white border-t border-slate-700">{card.title}</div>
                    </motion.div>
                 );
              })}
              <motion.div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-50 pointer-events-none translate-y-24">
                 <div className="bg-slate-900/90 text-white px-4 py-2 rounded-full border border-slate-600 flex items-center gap-2 shadow-xl"><Icons.Layers size={16}/> View Docs</div>
              </motion.div>
           </motion.div>
           <div className="absolute bottom-10 text-slate-500 text-sm animate-bounce">Click to preview Project Files</div>
        </div>

        <AnimatePresence>
          {isOpen && (
             <div className="fixed inset-0 z-[20000] bg-black/95 flex items-center justify-center p-4" onClick={()=>setIsOpen(false)}>
                <div className="relative w-full max-w-5xl h-full flex flex-col bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden" onClick={e=>e.stopPropagation()}>
                   <div className="p-4 flex justify-between items-center border-b border-slate-800">
                      <h3 className="text-xl font-bold text-white">{FAN_CARDS_DATA[activeIndex].title}</h3>
                      <button onClick={()=>setIsOpen(false)} className="text-white"><Icons.X /></button>
                   </div>
                   <div className="flex-1 bg-slate-950 p-4 flex items-center justify-center relative">
                      {(() => {
                        const active = FAN_CARDS_DATA[activeIndex];
                        const src = active.docUrl || active.url;
                        const isPdf = String(src || "").toLowerCase().endsWith(".pdf");

                        // Mobile UX: use PNG preview instead of embedded PDF (phone PDF viewers often open zoomed and require panning).
                        const isMobile = typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;
                        const displaySrc = (isMobile && isPdf) ? active.url : src;
                        const displayIsPdf = (!isMobile) && isPdf;

                        return displayIsPdf ? (
                          <iframe src={displaySrc} className="w-full h-full rounded-lg bg-white" title={active.title} />
                        ) : (
                          <img src={displaySrc} className="max-w-full max-h-full object-contain"/>
                        );
                      })()}
                      <button className="absolute left-4 p-3 bg-slate-800/80 rounded-full text-white" onClick={e=>{e.stopPropagation();setActiveIndex((activeIndex-1+FAN_CARDS_DATA.length)%FAN_CARDS_DATA.length)}}><Icons.ChevronLeft/></button>
                      <button className="absolute right-4 p-3 bg-slate-800/80 rounded-full text-white" onClick={e=>{e.stopPropagation();setActiveIndex((activeIndex+1)%FAN_CARDS_DATA.length)}}><Icons.ChevronRight/></button>
                   </div>
                </div>
             </div>
          )}
        </AnimatePresence>
      </>
    );
  };

  const VisualDesignSection = () => (
    <section id="design" className="py-24 bg-slate-900">
       <div className="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div className="flex-1 space-y-8">
             <h2 className="text-3xl font-bold text-white">Smart Objects. <br/><span className="text-brand-500">Not Just Icons.</span></h2>
             <p className="text-lg text-slate-400">MarkApp doesn't just place images on a PDF. You are placing <strong>Smart Data Objects</strong>. Every switch, sensor, light & product carries metadata for attributes, compatibility, pricing, and labour units.</p>
             <div className="grid sm:grid-cols-2 gap-4">
                <div className="bg-slate-800/50 p-4 rounded border border-brand-500/30 shadow-[0_0_15px_rgba(14,165,233,0.1)]"><div className="flex items-center gap-2 font-bold mb-2 text-white"><Icons.Network className="text-brand-500" size={16}/> Dependency Logic</div><p className="text-sm text-slate-400">MarkApp knows that a product needs a critical accessory, & alerts you if items need adding to the design.</p></div>
                <div className="bg-slate-800/50 p-4 rounded border border-brand-500/30 shadow-[0_0_15px_rgba(14,165,233,0.1)]"><div className="flex items-center gap-2 font-bold mb-2 text-white"><Icons.Cpu className="text-brand-500" size={16}/> Clickable Objects</div><p className="text-sm text-slate-400">Your plan is a live document where objects on the plan can give you pricing, images & other details - years after doing the design.</p></div>
             </div>
             <ul className="space-y-4 pt-4 border-t border-slate-800">
               {["Instant Bill of Materials generation", "Automated Purchase Orders by supplier", "Client-facing Product Schedules"].map((item, i) => (
                 <li key={i} className="flex items-center gap-3 text-slate-300">
                    <div className="w-6 h-6 rounded-full bg-brand-500/20 flex items-center justify-center"><div className="w-2 h-2 rounded-full bg-brand-500"></div></div>
                    {item}
                 </li>
               ))}
             </ul>
          </div>
          <div className="flex-1 w-full"><FanOutCards /></div>
       </div>
    </section>
  );

  const TimelineSection = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start center", "end center"] });
    // Laser Line Logic
    const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

    const steps = [
       {t:"Project Initiation", s:"PROJECT", d:"Kick off every project with aligned documentation. Create a job file, upload site documents and floorplans, and invite stakeholders to a central digital workspace.", i:Icons.FileText},
       {t:"Client Consultation", s:"DESIGN", d:"Conduct consultations in-person or online. Mark up floor plans with integrated products (Power, Lighting, Data, Automation). Real-time rules prevent missing dependencies.", i:Icons.PenTool},
       {t:"Immediate Quote", s:"QUOTE", d:"Simultaneously generate the Quote and Bill of Materials. Capture client signatures during the appointment to move the job forward immediately.", i:Icons.DollarSign},
       {t:"Construction Phase", s:"BUILD", d:"Manage Rough In and Fit Off tasks. Site managers access documents from phones, log variations, and upload progress photos for a full audit trail.", i:Icons.Hammer},
       {t:"Support & Warranty", s:"HANDOVER", d:"MarkApp becomes a permanent repository for the home's data. Simplify warranty claims and unlock future revenue opportunities with maintenance and upgrades.", i:Icons.ShieldCheck}
    ];
    return (
      <section id="timeline" ref={ref} className="py-24 bg-slate-950 relative overflow-hidden">
         <div className="max-w-7xl mx-auto px-4 relative">
            <h2 className="text-3xl font-bold text-white text-center mb-16">One Platform. <span className="text-brand-500">Entire Lifecycle.</span></h2>
            <div className="relative">
               {/* 1. Static Line (Background) - Z-0 */}
               <div className="absolute left-4 md:left-1/2 w-1 top-0 bottom-0 bg-slate-800 -translate-x-1/2 rounded-full z-0"></div>

               {/* 2. Laser Line (Foreground) - Z-10 */}
               <motion.div style={{scaleY}} className="absolute left-4 md:left-1/2 transform -translate-x-1/2 w-1 top-0 bottom-0 bg-white shadow-[0_0_10px_rgba(255,255,255,0.8)] origin-top z-10 rounded-full"></motion.div>

               {steps.map((s,i) => (
                  <motion.div key={i} initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true,margin:"-100px"}} transition={{delay:i*0.1}} className={`relative flex items-center mb-16 ${i%2===0?'md:flex-row':'md:flex-row-reverse'} flex-row z-20`}>
                     <div className="w-full md:w-5/12 p-4 z-20 pl-16 md:pl-0">
                        <div className={`bg-slate-900 p-6 rounded-xl border border-slate-800 ${i%2===0?'md:text-right':''} text-left`}>
                           <span className="text-brand-500 font-bold text-sm tracking-widest uppercase">{s.s}</span>
                           <h3 className="text-2xl font-bold text-white mb-2">{s.t}</h3>
                           <p className="text-slate-400 leading-relaxed text-sm">{s.d}</p>
                        </div>
                     </div>
                     <div className="absolute left-4 md:left-1/2 -translate-x-1/2 w-10 h-10 bg-brand-600 rounded-full border-4 border-slate-950 z-30 flex items-center justify-center text-white shadow-[0_0_15px_rgba(255,255,255,0.5)]">
                        <s.i size={16} />
                     </div>
                     <div className="w-full md:w-5/12 hidden md:block"></div>
                  </motion.div>
               ))}
            </div>
         </div>
      </section>
    );
  };

  const FeaturesGrid = () => {
    const items = [
      {i:Icons.Database, t:"Single Source of Truth", d:"MarkApp stores all sales, product, and client data in a unified schema, ensuring that the 'As-Built' documentation matches the visual plan exactly."},
      {i:Icons.History, t:"Full Audit Trail", d:"Track every change. Tasks such as variations trigger actions, logs, and fee adjustments automatically."},
      {i:Icons.ShieldCheck, t:"Warranty Support", d:"One-click access to warranty info for every installed device years down the line."},
      {i:Icons.Cpu, t:"Automation Logic", d:"Define scenes and schedules directly on the plan for Smart Home integrations."},
      {i:Icons.Layers, t:"Multi-Layered Design", d:"Toggle between Power, Data, HVAC, Security, and Automation layers instantly."},
      {i:Icons.Smartphone, t:"Mobile Field App", d:"Give your team access to the interactive plans on site. No more paper drawings getting lost or damaged. Mark deviations in real-time."}
    ];

    return (
       <section id="management" className="py-24 bg-slate-950">
          <div className="max-w-7xl mx-auto px-4">
             <div className="text-center mb-16">
               <h2 className="text-3xl font-bold text-white mb-4">Complete Job Lifecycle Management</h2>
               <p className="text-slate-400 max-w-2xl mx-auto">From the first wire drawn to the final warranty claim years later, MarkApp is the operating system for your electrical business.</p>
             </div>
             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {items.map((it, idx) => (
                    <motion.div key={idx} whileHover={{y:-5}} className="p-6 rounded-2xl bg-slate-800/50 border border-slate-700 hover:bg-slate-800 transition-all h-full flex flex-col">
                        <div className="w-12 h-12 rounded-lg bg-slate-700 flex items-center justify-center mb-4 text-brand-400 flex-shrink-0"><it.i size={24}/></div>
                        <h3 className="text-xl font-bold text-white mb-2">{it.t}</h3>
                        <p className="text-slate-400 text-sm leading-relaxed flex-grow">{it.d}</p>
                    </motion.div>
                ))}
             </div>
          </div>
       </section>
    );
  };

  const PricingSection = () => {
    const scenarios = [
      { name: "Pacific Homes", type: "Volume Builder", icon: Icons.HardHat, desc: "1x Business Core (HQ), 2x Design (Studio), and 5x Project (Site Supervisors) for seamless handover from sales to site." },
      { name: "ACE Electricians", type: "Contractor", icon: Icons.Zap, desc: "1x Business Core (Owner), 1x Design (Estimator), and 10x Project (Techs) to access plans and checklists on-site." },
      { name: "Lumix Lighting", type: "Showroom Retail", icon: Icons.Lightbulb, desc: "1x Business Core (Manager) and 4x Design (Consultants) to design lighting plans live with customers in-store." }
    ];
    return (
     <section id="pricing" className="py-24 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4">
           <h2 className="text-3xl font-bold text-white text-center mb-4">Simple, Transparent Pricing</h2>
           <p className="text-slate-400 text-center max-w-2xl mx-auto mb-16">Scale your team without breaking the bank. Replace multiple disconnected subscriptions with one Operating System.</p>

           <div className="max-w-5xl mx-auto grid gap-8">
              <div className="bg-slate-900/50 border-2 border-brand-500 rounded-2xl p-8 relative overflow-hidden">
                 <div className="absolute top-0 right-0 bg-brand-600 text-white text-xs font-bold px-3 py-1 rounded-bl">REQUIRED PLATFORM LICENSE</div>
                 <div className="flex flex-col md:flex-row gap-8 justify-between items-center relative z-10">
                    <div>
                       <h3 className="text-2xl font-bold text-white">Business Core</h3>
                       <p className="text-brand-400 mb-4 font-medium">Your Private Server Instance</p>
                       <p className="text-slate-400 mb-6 text-sm max-w-md">This is the mandatory foundation of your system. It hosts your database, client portal, quoting engine, and job files.</p>
                       <div className="grid grid-cols-2 gap-3 text-sm text-slate-300">
                          <div className="flex gap-2"><Icons.Check size={16} className="text-brand-500"/> Unlimited Jobs</div>
                          <div className="flex gap-2"><Icons.Check size={16} className="text-brand-500"/> Quote & BOM Engine</div>
                          <div className="flex gap-2"><Icons.Check size={16} className="text-brand-500"/> CRM & Client Portal</div>
                          <div className="flex gap-2"><Icons.Check size={16} className="text-brand-500"/> Includes 1 Admin Seat</div>
                       </div>
                    </div>
                    <div className="text-center bg-slate-950/50 p-6 rounded-xl border border-slate-800 min-w-[200px]">
                       <div className="text-4xl font-bold text-white">$333<span className="text-sm text-slate-500">/mo</span></div>
                       <div className="text-xs text-brand-400 mt-1 bg-brand-900/30 px-2 py-1 rounded-full inline-block">Billed Quarterly ($999)</div>
                       <p className="text-[10px] text-slate-500 mt-2">Guarantees uptime & updates.</p>
                    </div>
                 </div>
              </div>
              <div className="grid md:grid-cols-2 gap-8">
                 <div className="bg-slate-900 p-8 rounded-2xl border border-slate-800">
                    <Icons.HardHat size={32} className="text-brand-500 mb-4"/>
                    <h3 className="text-xl font-bold text-white">Project License</h3>
                    <p className="text-slate-400 text-sm mb-6 h-10">For field staff, site managers, and installers.</p>
                    <div className="border-t border-slate-800 pt-6">
                       <div className="text-3xl font-bold text-white mb-1">$20<span className="text-sm text-slate-500"> / user / mth</span></div>
                       <ul className="space-y-2 mt-4 text-xs text-slate-400">
                          <li className="flex gap-2"><Icons.Check size={14} className="text-brand-500"/> View Interactive Plans</li>
                          <li className="flex gap-2"><Icons.Check size={14} className="text-brand-500"/> Upload Site Photos</li>
                          <li className="flex gap-2"><Icons.Check size={14} className="text-brand-500"/> Complete Checklists</li>
                       </ul>
                    </div>
                 </div>
                 <div className="bg-slate-900 p-8 rounded-2xl border border-slate-800">
                    <Icons.Calculator size={32} className="text-brand-500 mb-4"/>
                    <h3 className="text-xl font-bold text-white">Design License</h3>
                    <p className="text-slate-400 text-sm mb-6 h-10">For estimators, consultants, and project designers.</p>
                    <div className="border-t border-slate-800 pt-6">
                       <div className="text-3xl font-bold text-white mb-1">$165<span className="text-sm text-slate-500"> / user / mth</span></div>
                       <ul className="space-y-2 mt-4 text-xs text-slate-400">
                          <li className="flex gap-2"><Icons.Check size={14} className="text-brand-500"/> Full Design Studio Access</li>
                          <li className="flex gap-2"><Icons.Check size={14} className="text-brand-500"/> Auto-Generate BOMs</li>
                          <li className="flex gap-2"><Icons.Check size={14} className="text-brand-500"/> Live Validation Logic</li>
                       </ul>
                    </div>
                 </div>
              </div>
              <div className="mt-8 border-t border-slate-800 pt-12 relative">
                 <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-slate-800 text-brand-400 text-xs font-bold px-3 py-1 rounded-full border border-slate-700 uppercase tracking-widest flex items-center gap-2">
                   <Icons.Users size={12}/> Common Team Setups
                 </div>
                 <div className="grid md:grid-cols-3 gap-6">
                    {scenarios.map((sc, i) => (
                      <div key={i} className="bg-slate-900 border border-slate-800 p-5 rounded-xl flex gap-4">
                         <div className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center text-brand-400 flex-shrink-0 border border-slate-700"><sc.icon size={20}/></div>
                         <div>
                            <h4 className="text-white font-bold text-sm">{sc.name}</h4>
                            <div className="text-xs text-brand-500 font-bold uppercase mb-2">{sc.type}</div>
                            <p className="text-xs text-slate-400 leading-relaxed">{sc.desc}</p>
                         </div>
                      </div>
                    ))}
                 </div>
              </div>
           </div>
        </div>
     </section>
    );
  };

  const WaitlistForm = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const handleSubmit = (e) => {
      e.preventDefault();
      if (!email) return;
      window.location.href = `mailto:ivanrostas@markapp.cloud?subject=MarkApp Waitlist&body=Please add me to the MarkApp waitlist:%0D%0A%0D%0A${encodeURIComponent(email)}`;
      setEmail('');
    };

    return (
       <section id="waitlist" className="py-24 bg-gradient-to-b from-slate-950 to-brand-950 relative overflow-hidden text-center">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[1000px] h-[500px] bg-brand-600/20 rounded-full blur-[100px] pointer-events-none"></div>
          <div className="max-w-4xl mx-auto px-4 relative z-10">
             <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Ready to Modernize Your Workflow?</h2>
             <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">MarkApp.cloud launches in <span className="text-brand-400 font-bold">Q1 2026</span>. Secure your spot on the waitlist.</p>
             <div className="max-w-md mx-auto">
               <form onSubmit={handleSubmit} className="relative">
                 <div className="relative flex items-center">
                   <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email address" disabled={status === 'success' || status === 'submitting'}
                     className="w-full px-6 py-4 rounded-full bg-slate-900/80 border border-slate-700 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all disabled:opacity-50"/>
                   <button type="submit" disabled={status === 'success' || status === 'submitting'} className="absolute right-2 top-2 bottom-2 bg-brand-600 hover:bg-brand-500 text-white rounded-full px-6 font-medium transition-colors disabled:opacity-50 flex items-center justify-center min-w-[100px]">
                     {status === 'submitting' ? (<div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>) : status === 'success' ? (<Icons.CheckCircle className="w-5 h-5" />) : (<span className="flex items-center gap-2">Join <Icons.Send className="w-4 h-4" /></span>)}
                   </button>
                 </div>
               </form>
               {status === 'success' && (
                 <div className="mt-4 p-4 bg-green-500/10 border border-green-500/20 rounded-lg flex items-center justify-center gap-2 text-green-400 animate-pulse">
                   <Icons.CheckCircle className="w-5 h-5" /><span>We've added you to the list!</span>
                 </div>
               )}
             </div>
             <p className="mt-8 text-sm text-slate-500">Join 2,500+ Electricians and Integrators waiting for launch.</p>
          </div>
       </section>
    );
  };

  const Footer = () => (
     <footer className="py-12 bg-slate-950 relative z-10">
        <div className="h-px bg-slate-800 w-full max-w-7xl mx-auto mb-12"></div>
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm">
           <div className="text-slate-200 font-bold mb-4 md:mb-0">MARKAPP.</div>
           <div className="flex gap-8 text-slate-400">
             <a href="#" className="hover:text-white">Privacy</a>
             <a href="#" className="hover:text-white">Terms</a>
             <a href="#" className="hover:text-white">Contact</a>
           </div>
        </div>
        <div className="mt-8 text-center text-xs text-slate-600">&copy; {new Date().getFullYear()} MarkApp Cloud Systems.</div>
     </footer>
  );

  const SectionDivider = () => (
    <div className="w-full max-w-7xl mx-auto px-4 relative z-10"><div className="h-px w-full bg-gradient-to-r from-transparent via-brand-500/30 to-transparent" /></div>
  );

  function App() {
     return (
        <div className="bg-slate-950 min-h-screen text-slate-200">
           <Navbar/>
           <Hero/>
           <SectionDivider/>
           <ProblemSection/>
           <SectionDivider/>
           <VisualDesignSection/>
           <SectionDivider/>
           <TimelineSection/>
           <SectionDivider/>
           <FeaturesGrid/>
           <SectionDivider/>
           <PricingSection/>
           <SectionDivider/>
           <WaitlistForm/>
           <Footer/>
        </div>
     );
  }

export default App;